import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const insuranceReportHeaderDetailsRowStyles = (isSmallOrMediumDevice: boolean) =>
  css({
    display: 'flex',
    width: '100%',
    gap: theme.spacing(3),
    flexDirection: isSmallOrMediumDevice ? 'column' : 'row',
    '> div': {
      flex: 1,
    },
  });
